import React, { useEffect } from "react";
import { withStyles, createStyles, Theme } from "@material-ui/core/styles";
import Check from "@material-ui/icons/Check";
import Close from "@material-ui/icons/Close";

const checkboxStyles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      width: "100%",
      border: "none",
    },
    input: {
      width: "20px",
      height: "20px",
    },
  });

const CheckboxEditorUnstyled = ({ classes, row, column, onRowChange }) => {
  const ref = React.useRef(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.focus();
      ref.current.select();
    }
  }, [ref]);

  const handleChange = (event) => {
    onRowChange({ ...row, [column.key]: event.target.checked });
  };

  const handleKeyPress = (event) => {
    // tab key press
    if (event.keyCode === 9 || event.keyCode === 27) {
      event.preventDefault();
      onRowChange(row, true);
    }
  };

  return (
    <div className={classes.root}>
      <input className={classes.input} ref={ref} type="checkbox" checked={row[column.key]} onChange={handleChange} onKeyDown={handleKeyPress} />
    </div>
  );
};

export const CheckboxEditor = withStyles(checkboxStyles)(CheckboxEditorUnstyled);

const CheckboxFormatterUnstyled = ({ classes, row, column }) => {
  const data = row[column.key];

  if (data && data == 1) {
    return (
      <div className={classes.root}>
        <Check style={{ color: "green" }} />
      </div>
    );
  }
  return (
    <div className={classes.root}>
      <Close style={{ color: "red" }} />
    </div>
  );
};

export const CheckboxFormatter = withStyles(checkboxStyles)(CheckboxFormatterUnstyled);
